import React, { useState } from "react";
import styles from "./LaserCuttingForm.module.css";
import { Field, Formik, Form } from "formik";
import {
  Button,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import { submitFormLaserCutting } from "../../actions/Form.action";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { MultiSelect, Select } from "@mantine/core";

const LaserCuttingForm = ({ submitFormLaserCutting, data }) => {
  const [submitting, setSubmitting] = useState(false);
  const [file, setFile] = useState(false);
  const navigate = useNavigate();
  const onSubmitHandeler = async (values) => {
    setSubmitting(true);
    if (!file) {
      toast.error("Please upload file!");
      setSubmitting(false);
      return;
    }
    if (Object.keys(data).length === 0) {
      toast.error("Please fill these fields!");
      setSubmitting(false);
      navigate("/order");
      return;
    }
    console.log(values);
    let check = await submitFormLaserCutting(values, data, file);

    if (check === true) {
      setSubmitting(false);
      navigate(`/`);
    } else {
      setSubmitting(false);
    }
  };
  let initVals = {
    material: "Maple",
    materialNeeded: "Yes",
    thickness: "1mm",
    color: "",
    details: "",
    quantity: "",
  };

  const OrderSchema = Yup.object().shape({
    material: Yup.string().required("Material is required!"),
    materialNeeded: Yup.string().notRequired(),
    thickness: Yup.string().required("Thickness is required!"),
    color: Yup.string().required("Color is required!"),
    details: Yup.string().required("Details is required!"),
    quantity: Yup.string().required("Quantity  is required!"),
  });

  return (
    <div className={styles.wrapper}>
      <h2 className="pt-4 px-5">Laser Cutting Order</h2>
      <Formik
        initialValues={initVals}
        validationSchema={OrderSchema}
        enableReinitialize
        onSubmit={(values) => onSubmitHandeler(values)}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <Container className="p-md-5 p-3 pt-3 pt-md-3">
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="materialNeeded" className="d-block">
                        Material needed?
                      </label>
                      {errors.materialNeeded && touched.materialNeeded ? (
                        <small className="text-danger">
                          {errors.materialNeeded}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Select}
                      name="materialNeeded"
                      isValid={!errors.materialNeeded && touched.materialNeeded}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={
                        errors.materialNeeded && touched.materialNeeded
                      }
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                  </InputGroup>
                </Col>{" "}
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="color" className="d-block">
                        Color preference
                      </label>
                      {errors.color && touched.color ? (
                        <small className="text-danger">{errors.color}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your color preference..."
                      name="color"
                      isValid={!errors.color && touched.color}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.color && touched.color}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="material" className="d-block">
                        Material
                      </label>
                      {errors.material && touched.material ? (
                        <small className="text-danger">{errors.material}</small>
                      ) : null}
                    </div>
                    <Field
                      as={Select}
                      data={[
                        "Maple",
                        "Acrylic",
                        "Plywood",
                        "Plastic Wood (PVC)",
                      ]}
                      onChange={(e) => setFieldValue("material", e)}
                      searchable
                      creatable
                      value={values.material}
                      getCreateLabel={(query) => `+ Create ${query}`}
                      onCreate={(query) => {
                        const item = { value: query, label: query };
                        return item;
                      }}
                      placeholder="Type your material ..."
                      name="material"
                      isValid={!errors.material && touched.material}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.material && touched.material}
                    />
                    {/* <small>
                      Maple, Acrylic, Plywood, Plastic Wood (PVC) are basic
                      material we provide. Type if you need any other material.
                    </small> */}
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="thickness" className="d-block">
                        Thickness
                      </label>
                      {errors.thickness && touched.thickness ? (
                        <small className="text-danger">
                          {errors.thickness}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={Select}
                      data={["1mm", "2mm", "3mm", "4mm", "5mm", "6mm"]}
                      onChange={(e) => setFieldValue("thickness", e)}
                      searchable
                      creatable
                      value={values.thickness}
                      getCreateLabel={(query) => `+ Create ${query}`}
                      onCreate={(query) => {
                        const item = { value: query, label: query };
                        return item;
                      }}
                      placeholder="Thickness..."
                      name="thickness"
                      isValid={!errors.thickness && touched.thickness}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.thickness && touched.thickness}
                    />
                    {/* <small>
                      We provide thickness from to 1mm to 6mm. Please type if
                      you need other thickness.
                    </small> */}
                  </InputGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="details" className="d-block">
                        Details
                      </label>
                      {errors.details && touched.details ? (
                        <small className="text-danger">{errors.details}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your details..."
                      name="details"
                      isValid={!errors.details && touched.details}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.details && touched.details}
                    ></Field>
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="quantity" className="d-block">
                        Quantity (According to the files)
                      </label>
                      {errors.quantity && touched.quantity ? (
                        <small className="text-danger">{errors.quantity}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your quantity ..."
                      name="quantity"
                      isValid={!errors.quantity && touched.quantity}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.quantity && touched.quantity}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <BootstrapForm.Group controlId="formFile" className="mb-3">
                    <BootstrapForm.Label>
                      Laser Cutting Files
                    </BootstrapForm.Label>
                    <BootstrapForm.Control
                      onChange={(e) => setFile(e.target?.files)}
                      type="file"
                    />
                  </BootstrapForm.Group>
                </Col>
              </Row>
              <Row>
                <Col className="pt-3 d-flex justify-content-center align-items-center">
                  <Button
                    type="submit"
                    className={`.btn_primary ${styles.btn}`}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Order"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.form.form,
});
export default connect(mapStateToProps, { submitFormLaserCutting })(
  LaserCuttingForm
);
